/**
 * JiraUserUpdater calls Jira's user client and uses the returned user
 * information to set value of UserContext.
 * TODO: Remove this hacky component when we move the Jira user fetching logic
 * into the Jira frontend repo.
 */

import React from 'react';
import { useUserContext } from '../../../../common/user-context';
import { useJiraCurrentUser } from '../../../../jira/clients';
export var JiraUserUpdater = function JiraUserUpdater(_ref) {
  var children = _ref.children;
  var _useUserContext = useUserContext(),
    user = _useUserContext.user,
    setUser = _useUserContext.setUser;
  var jiraUser = useJiraCurrentUser(user);
  setUser(jiraUser);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};